<form [formGroup]="filterForm">
  <div>
    <div
      class="flex-wrap align-items-center"
      style="
        grid-gap: 15px;
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
      "
    >
      <div>
        <p-multiSelect
          class="filter-multiselect narrow-multiselect"
          defaultLabel="All Suppliers"
          [options]="suppliers"
          formControlName="supplierIds"
        ></p-multiSelect>
      </div>
      <div>
        <p-multiSelect
          class="filter-multiselect narrow-multiselect"
          defaultLabel="All Supplier Types"
          [options]="supplierContractTypes"
          formControlName="supplierContractTypes"
        ></p-multiSelect>
      </div>

      <div>
        <p-multiSelect
          defaultLabel="All Customers"
          class="filter-multiselect narrow-multiselect"
          [options]="customers"
          formControlName="customerIds"
        ></p-multiSelect>
      </div>

      <div>
        <p-multiSelect
          defaultLabel="All Risk Types"
          class="filter-multiselect narrow-multiselect"
          [options]="riskTypes"
          formControlName="riskTypes"
        ></p-multiSelect>
      </div>

      <div>
        <p-multiSelect
          defaultLabel="All Review Statuses"
          class="filter-multiselect narrow-multiselect"
          [options]="reviewStatuses"
          formControlName="reviewStatuses"
        ></p-multiSelect>
      </div>

      <div>
        <p-multiSelect
          defaultLabel="Customer Priority"
          class="filter-multiselect narrow-multiselect"
          [options]="priorities"
          formControlName="priorities"
        ></p-multiSelect>
      </div>

      <div>
        <p-multiSelect
          defaultLabel="Service Type"
          class="filter-multiselect narrow-multiselect"
          [options]="serviceTypes"
          formControlName="serviceTypes"
        ></p-multiSelect>
      </div>

      <div class="flex gap-2">
        <div class="flex-shrink-1">
          <button class="button-style" (click)="searchClicked.emit(formControls)">
            <i class="fa fa-search"></i>&nbsp;Search
          </button>
        </div>

        <div class="flex-shrink-1">
          <button class="button-style ui-button-tertiary transparent" (click)="resetClicked()">
            <i class="fa fa-undo"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</form>
